module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"use-label":"Use Label","address-label-only":"Address Label Only","choose-address-label":"Choose Address Label","choose-collection-address":"Choose Collection Address"}}')
  delete Component.options._Ctor
}
